<template>
  <TemplateSignUp
    :has-logo-link="hasLogoLink"
    :has-sign-in-link="hasSignInLink">
    <template #main>
      <UsersSignUpMain
        @step:entrance="hasLogoLink = $event"
        @step:last="hasSignInLink = false" />
    </template>
  </TemplateSignUp>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import UsersSignUpMain from './Main.vue'
import TemplateSignUp from '@/components/_core/TemplateSignUp.vue'

export default defineComponent({
  name: 'UsersSignInApp',

  components: {
    UsersSignUpMain,
    TemplateSignUp,
  },

  setup() {
    const hasLogoLink = ref(true)
    const hasSignInLink = ref(true)

    return {
      // data
      hasLogoLink,
      hasSignInLink,
    }
  }
})
</script>
